<div class="number-input-wrapper" [class.ref]="!!_refValue">
  <input #input [id]="_id" [name]="_id" [formControl]="_inputControl" [class]="classNames" type="text" pattern="[0-9,.]" placeholder="0.00">
  <ng-container *ngIf="isCredit">
    <span class="ref-value dark" *ngIf="!showDiff && _refValue && _refValue !== _value"><strong>(${{_refDisplayValue }})</strong></span>
    <span class="ref-value dark" *ngIf="showDiff && _refDiff"><strong>(${{ diff ??_refDiff }})</strong></span>
  </ng-container>
</div>
